import { render, staticRenderFns } from "./ModalEditarUsuario.vue?vue&type=template&id=567e10be&"
import script from "./ModalEditarUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalEditarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports